import React, { useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import CancelIcon from "@mui/icons-material/Cancel";
import Date from "../../super_dashboard/components/Date";
import { useMutation } from "@tanstack/react-query";
import { createData } from "../../utility/superAdminApi";
import * as XLSX from "xlsx";

function DownloadSalesModal({ id }) {
  const [downloadModal, setDownloadModal] = useState(false);
  const [formData, setFormData] = useState({
    company_id: id,
    from: "",
    to: "",
  });

  const handleDateChange = (year, month, day, type) => {
    setFormData((prevData) => ({
      ...prevData,
      [type]: `${year}-${month}-${day}`,
    }));
  };

  const handleDownload = () => {
    setDownloadModal(true);
  };

  // const queryClient = useQueryClient();
  const downloadSales = useMutation({
    mutationFn: (formData) =>
      createData(`/api/superadmin/companies/download-sales`, formData),
    onSuccess: (response) => {
      const companyName = response?.data?.companyName;
      const filteredData = response?.data?.salesData?.map((item, index) => ({
        // "Image":,
        NO: index + 1,

        "ORDER NO": item?.orderNO,
        "CASHIER NAME": `${item?.user?.firstname} ${item?.user?.lastname}`,
        "CUSTOMER NAME": item?.customer?.name,
        "PAYMENT METHOD": item?.payment_type,
        "QUANTITY SOLD": item?.orderdetails[0]?.quantity_ordered,
        "TOTAL PRICE": item?.total_price,
        STATUS: item.status,
      }));

      const companyNameRow = [[`Company Name: ${companyName}`]]; // Making it a single row
      const salesHeaders = [
        [
          "NO",
          "ORDER NO",
          "CASHIER NAME",
          "CUSTOMER NAME",
          "PAYMENT METHOD",
          "QUANTITY SOLD",
          "TOTAL PRICE",
          "STATUS",
        ],
      ];

      // Convert sales data into a 2D array
      const salesData = response?.data?.salesData?.map((item, index) => [
        index + 1,
        item?.orderNO,
        `${item?.user?.firstname} ${item?.user?.lastname}`,
        item?.customer?.name,
        item?.payment_type,
        item?.orderdetails[0]?.quantity_ordered,
        item?.total_price,
        item?.status,
      ]);

      const finalData = companyNameRow.concat(salesHeaders, salesData);

      filteredData.push({ "Company Name": companyName });
      const ws = XLSX.utils.aoa_to_sheet(finalData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "Sales-inventory.xlsx");
      setDownloadModal(false);
    },
  });

  const handleSubmit = () => {
    downloadSales.mutate(formData);
  };

  return (
    <div>
      <DownloadIcon
        className="text-green-600 cursor-pointer"
        onClick={handleDownload}
      />
      {downloadModal && (
        <div className="fixed inset-0 flex justify-center items-start bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-4  my-12">
            <div className="flex justify-end">
              <CancelIcon
                onClick={() => setDownloadModal(false)}
                className="cursor-pointer text-black mb-2"
              />
            </div>
            <div className="flex flex-col gap-3 p-3">
              <div className="flex gap-4">
                <div className="flex flex-col w-full ">
                  <label htmlFor="Manufacturing Date">Start Date</label>
                  <Date
                    onDateChange={handleDateChange}
                    type={"from"}
                    className={"lg:w-full"}
                  />
                </div>
                <div className="flex flex-col w-full">
                  <label htmlFor="Expiring Date">End Date</label>
                  <Date
                    onDateChange={handleDateChange}
                    type={"to"}
                    className={"lg:w-full"}
                  />
                </div>
              </div>
              <div className="flex justify-center my-6 text-white font-medium text-xl  bg-darkblue rounded-lg ">
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="w-full h-full p-3"
                  disabled={downloadSales?.isPending}
                >
                  {downloadSales?.isPending ? "Downloading" : " Download"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DownloadSalesModal;
